(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['module'], factory);
    } else if (typeof exports !== "undefined") {
        factory(module);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod);
        global.index = mod.exports;
    }
})(this, function (module) {
    'use strict';

    var edapArray = [];

    // If edap does not exist, define array so push() method can raise the event
    if (typeof window !== 'undefined' && window !== null) {
        window.edap = window.edap || edapArray;
    }

    var edap = function edap() {
        if (typeof window !== 'undefined' && window !== null) {
            return window.edap;
        }
        return edapArray;
    };

    edap.triggerPageviewAndFlush = function () {
        var maxAttempts = 20;
        var attempts = 0;

        var edapInterval = setInterval(function () {
            if (attempts >= maxAttempts) {
                clearInterval(edapInterval);
            }

            if (typeof window.edap.trigger === 'function') {
                window.edap.trigger('edap.flush');
                window.edap.trigger('pageview');
                clearInterval(edapInterval);
            } else {
                attempts++;
            }
        }, 500);
    };

    module.exports = edap;
});